/*
 * @Author: lzy
 * @Date: 2021-05-11 15:53:07
 * @LastEditTime: 2021-05-12 11:06:13
 * @LastEditors: lzy
 * @Description: app详情页顶部操作按钮
 * @FilePath: \xjmediacloud\app\editingCenter\app\directive\previewBtns\previewBtns.js
 */

angular.module('websitePreviewModule').directive('websitePreviewBtns', ['$state', 'newMediaService', 'messagePublishService', 'sensitiveWordCheckService', 'editingCenterService', 'modalDialog', 'publicToolService', 'websiteConst',
    function($state, newMediaService, messagePublishService, sensitiveWordCheckService, editingCenterService, modalDialog, publicToolService, websiteConst) {
        return {
            scope: true,
            restrict: 'EA',
            replace: true,
            templateUrl: './editingCenter/website/preview/previewBtns/previewBtns.html',
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 初始化数据
                 *
                 * @return  {[type]}   [return description]
                 */
                function initStatus() {
                    $scope.data.trench = websiteConst.listenStroageKey;
                    $scope.list = $scope.data.item;
                }

                /**
                 * [initData description]
                 *
                 * @return  {[type]}   [return description]
                 */
                function initData() {
                    // publicToolService.getModeconfiguration('IM').then((config) => {
                    //     // 因为发送按钮不基于权限控制，只根据配置中心来决定，在这里添加可以便于修改每个编辑页面
                    //     $scope.status.canSendMessage = config && config.sendSwitch === 'on';
                    // });
                }

                /* 送审 */
                $scope.trial = function() {
                    $scope.loadingPromise = newMediaService.trial($scope, websiteConst.trialParams).then(function(opinion) {
                        let trialParams = angular.extend({
                            MetaDataIds: $scope.data.item.METADATAID,
                            ChnlDocIds: $scope.data.item.CHNLDOCID,
                            ChannelId: $scope.data.item.CHANNELID,
                            CurrChnlId: $scope.data.item.CHANNELID,
                            SiteId: $scope.data.item.SITEID,
                            Opinion: opinion,
                        }, websiteConst.trial);
                        messagePublishService.publish('doEditPageOperation', trialParams);
                    });
                };

                /* 直接签发 */
                $scope.directiveSign = function() {
                    var array = [$scope.data.item];
                    sensitiveWordCheckService.SensitiveWordsAndCareful(array, true, 2).then(
                        function () {
                            privateSign();
                        },
                        function () {
                            privateSign();
                        });
                };

                /**
                 * [privateSign description]签发
                 * @param   {[type]}  params  [isSaveAndPublish description] 各个流程的签发接口名
                 * @return  {[type]}  [return description]
                 */
                function privateSign() {
                    var methodname = ['webDaiBianPublish', 'webDaiShenPublish', 'webYiQianPublish'];
                    $scope.loadingPromise = newMediaService.sign($scope, '', function (params, array) {
                        var ChnlDocIds = [];
                        var ObjectIds = [];
                        for (var i = 0; i < array.length; i++) {
                            ChnlDocIds.push(array[i].DOC.CHNLDOCID);
                            ObjectIds.push(array[i].DOC.CHNLDOCID);
                        }
                        params.ChnlDocIds = ChnlDocIds.join(',');
                        params.ObjectIds = ObjectIds.join(',');
                    }).then(function () {
                        messagePublishService.publish('doEditPageOperation', angular.extend({
                            serviceid: 'mlf_websiteoper',
                            methodname: methodname[$state.params.wzplatform],
                            MetaDataIds: $scope.data.item.METADATAID,
                            ChnlDocIds: $scope.data.item.CHNLDOCID,
                            ChannelId: $scope.data.item.CHANNELID,
                            CurrChnlId: $scope.data.item.CHANNELID,
                            SiteId: $scope.data.item.SITEID,
                        }));
                    });
                }

                /* 定时签发 */
                $scope.timeSign = function() {
                    sensitiveWordCheckService.SensitiveWordsAndCarefulTiming([$scope.data.item], true).then(function () {
                        // 
                    }, function () {
                        var methodname = ['webDaiBianTimingPublish', 'webDaiShenTimingPublish'];
                        $scope.loadingPromise = newMediaService.timeSign($scope).then(function () {
                            let signParams = {
                                serviceid: 'mlf_websiteoper',
                                methodname: methodname[$state.params.wzplatform],
                                ObjectIds: $scope.data.item.CHNLDOCID,
                                ChnlDocIds: $scope.data.item.CHNLDOCID,
                                MetaDataIds: $scope.data.item.METADATAID,
                            };
                            messagePublishService.publish('doEditPageOperation', signParams);
                        });
                    });
                };

                /* 废稿 */
                $scope.deleteDraft = function() {
                    $scope.loadingPromise = newMediaService.delete($scope, websiteConst.delete);
                };

                // 撤稿
                $scope.revoke = function() {
                    newMediaService.rejection($scope, websiteConst.rejection).then((opinion) => {
                        let revokeParams = angular.extend({
                            MetaDataIds: $scope.data.item.METADATAID,
                            ChnlDocIds: $scope.data.item.CHNLDOCID,
                            ChannelId: $scope.data.item.CHANNELID,
                            CurrChnlId: $scope.data.item.CHANNELID,
                            SiteId: $scope.data.item.SITEID,
                            Opinion: opinion,
                        }, websiteConst.rejection);
                        messagePublishService.publish('doEditPageOperation', revokeParams);
                    });
                };

                /**
                 * [revise description]修订
                 * @return {[type]} [description]
                 */
                $scope.revise = function () {
                    var transferData = {
                        SiteId: $scope.data.item.SITEID,
                        DocIds: $scope.data.item.METADATAID,
                        ChnlDocIds: $scope.data.item.CHNLDOCID,
                        UserId: '',
                        MediaType: '2',
                    };
                    newMediaService.revise($scope, transferData);
                };

                // 取消签发
                $scope.retraction = function() {
                    $scope.loadingPromise = editingCenterService.beforeRetractOper([$scope.data.item]).then(function (data) {
                        if (data === 'noneed') {
                            retraction();
                        } else {
                            editingCenterService.beforeRetractionModel({
                                data: data,
                                selectedArray: [$scope.data.item],
                            }, function () {
                                retraction();
                            });
                        }
                    });
                };

                /**
                 * [retraction description]取消签发函数
                 * @return  {[type]}              [return description]
                 */
                function retraction() {
                    newMediaService.retraction($scope, websiteConst.withdrawrejection);
                }

                /**
                 * [tenantManuShare 租户间共享]
                 * @return {[type]} [description]
                 */
                $scope.tenantManuShare = function () {
                    if ($scope.data.item.DOCTYPEID === '3') {
                        modalDialog.alertType('无法进行共享', '所选稿件中包含专题稿', 'info', 'confirm');
                        return;
                    }
                    var params = {
                        serviceid: 'mlf_websiteoper',
                        methodname: 'pluralisticShare',
                        dataIds: $scope.data.item.METADATAID,
                        ChnlDocIds: $scope.data.item.CHNLDOCID,
                    };
                    $scope.loadingPromise = editingCenterService.tenantShareManu(params);
                };
            }
        };
    }
]);
